import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDraugiemDotLvComponent } from './simple-icons-draugiem-dot-lv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDraugiemDotLvComponent ],
    exports:      [ SimpleIconsDraugiemDotLvComponent ],
    bootstrap:    []
})
export class SimpleIconsDraugiemDotLvModule {}
